import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class ElderlyHomesIcon extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 300 300" xmlSpace="preserve">
                <circle className="st0" cx="150" cy="150" r="141"/>
                <circle className="st1" cx="150" cy="80.5" r="15.8"/>
                <path className="st2" d="M103.3,161.8c0,0-9-0.9-7-9.6c1.7-7.1,4.1-20.6,4.9-25.3c0.2-1.2,0.6-2.3,1.3-3.3c1.5-2.2,4.2-6.1,6.3-7.1
	c2.5-1.2,16-10,20.1-12.6c0.8-0.5,1.8-0.9,2.7-1.2c4.4-1.1,16.8-3,21.3,7.7c5.5,13.1,11.3,25.8,19.5,29.9
	c8.1,4.1,13.6,7.8,11.6,14.2s-9,5.5-13.1,4.1c-4.1-1.5-15.4-7.3-15.4-7.3"/>
                <path className="st2" d="M117.8,128.1c0,0-0.9,52.3-5.2,69.4c-3.6,14.4-6.3,27.3-7,31.1c-0.2,0.8-0.1,1.7,0.1,2.5
	c0.6,2.3,2.2,6.6,5.9,7.6c5.1,1.5,8.3-2.3,10-4.9c1.7-2.6,9.6-34.3,8.7-48.5"/>
                <path className="st2" d="M143.3,128.1V164c0,0.8,0.3,1.6,0.8,2.2l15.8,16.2c0.6,0.7,1.6,2.7,1.7,3.6l1.5,41.1c0,0.9,0.3,3.3-1.6,5.2
	c-1.4,1.5-2.8,2.5-7.8,2.3c-7.5-0.3-7.7-6.4-7.7-6.4l-2.6-38.6c-0.1-0.7-0.4-1.4-0.9-1.9l-26.1-23.5"/>
                <path className="st3" d="M179.6,173.6c0,0-6.4-18.3,9.6-17.4c0,0,9.9,0,10.2,11c0.3,11,0,72.9,0,72.9"/>
            </svg>
        );
    }
}